import React from 'react';
import classNames from 'classnames';
import { ControlledRadioButtonControl } from 'src/components/ui/RadioButtonControl/RadioButtonControl';

import { useTranslation } from 'react-i18next';
import { Control, useWatch } from 'react-hook-form';
import styles from './Tracking.module.scss';
import { OverlaySectionHeadline } from '../../OverlaySectionHeadline/OverlaySectionHeadline';
import { ProductFormValues } from '../ProductFormTypes';

export interface TrackingProps {
  editModeActive?: boolean;
  control: Control<ProductFormValues>;
}

const Tracking: React.FC<TrackingProps> = ({ editModeActive, control }) => {
  const { t } = useTranslation();
  const productState = useWatch({ control, name: 'productStatus' });
  const locked = !!productState && productState !== 'Draft';
  const tracking = useWatch({ control, name: 'tracking' });

  return (
    <div className={classNames(styles.root)}>
      <OverlaySectionHeadline as="h4">{t('general.tracking')}</OverlaySectionHeadline>
      <ControlledRadioButtonControl
        control={control}
        name="tracking"
        options={[
          { label: 'Serial', value: 'serial' },
          { label: 'Lot', value: 'lot' },
          { label: 'None', value: 'none' },
        ]}
        defaultValue={tracking || 'none'}
        // defaultValue="lot"
        // onChange={v => onUpdate('tracking', v)}
        disabled={locked || !editModeActive}
      />
    </div>
  );
};

export default Tracking;
